import React, { useState, useEffect } from "react";
import Navbar from "./../Navbar";
import TopBar from "./../topbar";
import Footer from "./../../layout/footer";
import { NavLink, Switch, Route } from "react-router-dom";
import constant from "../../_config/constant";

import PaymentMethod from "./PaymentMethod";
import SubscriptionPlans from "./SubscriptionPlans";

import { getData } from "../../_helpers";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Subscription = () => {
  const [requesting, setRequesting] = useState(false);

  useEffect(() => {
  }, []);

  const decoded = getData();

  return (
    <div id="main-wrapper">
      <TopBar
        user={decoded}
        title="Subscription"
      />
      <div className="deznav">
        <div className="deznav-scroll">
          <Navbar />
        </div>
      </div>
      <ToastContainer />

      <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
          {requesting && (
              <div className="tw-my-10 tw-flex tw-items-center tw-justify-center">
                <div className="bg-white tw-w-max rounded shadow-md p-4">
                  <div className="loader"></div>
                </div>
              </div>
            )}
            <div className="tw-col-lg-6 tw-w-full tw-max-w-md tw-grid tw-grid-cols-[repeat(auto-fit,minmax(150px,1fr))] tw-ring-1 tw-ring-[#23426e] tw-rounded-md tw-overflow-hidden">
              <NavLink
                exact
                to="/subscription"
                className="tw-text-sm tw-p-4 tw-text-center tw-break-words tw-leading-tight"
                activeClassName="tw-bg-[#23426e] tw-text-white"
              >
                Subscription Plans
              </NavLink>

              <NavLink
                exact
                to="/subscription/manage-payment"
                className="tw-text-sm tw-p-4 tw-text-center tw-break-words tw-leading-tight"
                activeClassName="tw-bg-[#23426e] tw-text-white"
              >
                Manage Payment Method
              </NavLink>
            </div>
            </div>
            <Switch>
              <Route exact component={SubscriptionPlans} path="/subscription" />
              <Route
                exact
                component={PaymentMethod}
                path="/subscription/manage-payment"
              />
            </Switch>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Subscription;